"use client";

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from "next/navigation";
import { ProfileActivityLogProxyActionChanged } from "@/entities/IProfile";
import ProfileActivityLogItemAction from "./utils/ProfileActivityLogItemAction";
import { USER_PAGE_TAB_IDS } from "@/components/user/layout/userTabs.config";
import CommonProfileLink from "@/components/user/utils/CommonProfileLink";
import { PROFILE_PROXY_ACTION_LABELS } from "@/entities/IProxy";
import { formatNumberWithCommas } from "@/helpers/Helpers";
export default function ProfileActivityLogProxyActionChange(t0) {
  const $ = _c(28);
  const {
    log
  } = t0;
  const searchParams = useSearchParams();
  const handleOrWallet = log.target_profile_handle ?? "";
  let t1;
  if ($[0] !== searchParams) {
    t1 = (searchParams?.get("user") as string)?.toLowerCase();
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== handleOrWallet) {
    t2 = handleOrWallet.toLowerCase();
    $[2] = handleOrWallet;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const isCurrentUser = t1 === t2;
  const tabTarget = USER_PAGE_TAB_IDS.PROXY;
  let t3;
  if ($[4] !== log.contents.credit_amount || $[5] !== log.contents.end_time) {
    t3 = () => {
      if (log.contents.end_time !== undefined) {
        return "end time to";
      }
      if (log.contents.credit_amount !== undefined) {
        return "credit amount to";
      }
      return "";
    };
    $[4] = log.contents.credit_amount;
    $[5] = log.contents.end_time;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const getChangedParamName = t3;
  let t4;
  if ($[7] !== log.contents.credit_amount || $[8] !== log.contents.end_time) {
    t4 = () => {
      if (log.contents.end_time !== undefined) {
        return log.contents.end_time ? new Date(log.contents.end_time).toLocaleString() : "indefinite";
      }
      if (log.contents.credit_amount !== undefined) {
        return formatNumberWithCommas(log.contents.credit_amount);
      }
      return "";
    };
    $[7] = log.contents.credit_amount;
    $[8] = log.contents.end_time;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const getChangeParamValue = t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ProfileActivityLogItemAction action="changed" />;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== handleOrWallet || $[12] !== isCurrentUser) {
    t6 = <CommonProfileLink handleOrWallet={handleOrWallet} isCurrentUser={isCurrentUser} tabTarget={tabTarget} />;
    $[11] = handleOrWallet;
    $[12] = isCurrentUser;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <ProfileActivityLogItemAction action="proxy" />;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = PROFILE_PROXY_ACTION_LABELS[log.contents.type];
  let t9;
  if ($[15] !== t8) {
    t9 = <span className="tw-whitespace-nowrap tw-text-base tw-font-medium tw-text-iron-200">{t8}</span>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = getChangedParamName();
  let t11;
  if ($[17] !== t10) {
    t11 = <ProfileActivityLogItemAction action={t10} />;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== getChangeParamValue) {
    t12 = getChangeParamValue();
    $[19] = getChangeParamValue;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t12) {
    t13 = <span className="tw-whitespace-nowrap tw-text-base tw-font-medium tw-text-iron-200">{t12}</span>;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t11 || $[24] !== t13 || $[25] !== t6 || $[26] !== t9) {
    t14 = <>{t5}{t6}{t7}{t9}{t11}{t13}</>;
    $[23] = t11;
    $[24] = t13;
    $[25] = t6;
    $[26] = t9;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
}